import { render, staticRenderFns } from "./rolesM.vue?vue&type=template&id=68f5a2b3&scoped=true&"
import script from "./rolesM.vue?vue&type=script&lang=js&"
export * from "./rolesM.vue?vue&type=script&lang=js&"
import style0 from "./rolesM.vue?vue&type=style&index=0&id=68f5a2b3&lang=scss&scoped=true&"
import style1 from "./rolesM.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5a2b3",
  null
  
)

export default component.exports